// Provider
import { CreateProviderModalDialog } from '@Features/provider/createProvider/CreateProviderModalDialog';
import { CreateProviderCancelModalDialog } from '@Features/provider/createProvider/CreateProviderCancelModalDialog';
import { SetupProviderDrawer } from '@Features/providers/drawer/SetupProviderDrawer';
import { SetupProviderDrawerCancelDialog } from '@Features/providers/drawer/SetupProviderDrawerCancelDialog';
import { DeleteProviderModalDialog } from '@Features/provider/deleteProvider/DeleteProviderModalDialog';
import { CreateProviderConfigModalDialog } from '@Features/provider/createProviderConfig/CreateProviderConfigModalDialog';
import { CreateProviderConfigCancelModalDialog } from '@Features/provider/createProviderConfig/CreateProviderConfigCancelModalDialog';
import { UpdateProviderConfigModalDialog } from '@Features/provider/updateProviderConfig/UpdateProviderConfigModalDialog';
import { UpdateProviderConfigCancelModalDialog } from '@Features/provider/updateProviderConfig/UpdateProviderConfigCancelModalDialog';
// Round
import { SetupRoundDrawer } from '@Features/rounds/SetupRound/SetupRoundDrawer';
import { CreateRoundConfigModalDialog } from '@Features/rounds/CreateRoundConfig/CreateRoundConfigModalDialog';
import { CreateRoundConfigCancelModalDialog } from '@Features/rounds/CreateRoundConfig/CreateRoundConfigCancelModalDialog';
import { SetupAvTransactionDrawer } from '@Features/transaction/SetupAvTransactionDrawer/SetupAvTransactionDrawer';
// Users
import { CreateUserModalDialog } from '@Features/users/CreateUser/CreateUserModalDialog';
import { CreateUserCancelModalDialog } from '@Features/users/CreateUser/CreateUserCancelModalDialog';
import { SetupAviatorRoleDrawer } from '@Features/users/SetupAviatorRoleDrawer/SetupAviatorRoleDrawer';
import { CreateAviatorRoleModalDialog } from '@Features/users/CreateAviatorRole/CreateAviatorRoleModalDialog';
import { CancelCreateAviatorRoleModalDialog } from '@Features/users/CreateAviatorRole/CancelCreateAviatorRoleModalDialog';
import { SetupAviatorRoleDeleteModalDialog } from '@Features/users/SetupAviatorRoleDrawer/SetupAviatorRoleDeleteModalDialog';
import { DeleteProviderConfigModalDialog } from '@Features/provider/deleteProviderConfig/DeleteProviderConfigModalDialog';
// import { UpdateRoundStatusModalDialog } from '@Features/rounds/RoundStatus/UpdateRoundStatusModalDialog';
import { CreateAviatorPermissionModalDialog } from '@Features/users/CreateAviatorPermission/CreateAviatorPermissionModalDialog';
import { SelectedRolePermissionDeleteModalDialog } from '@Features/users/CreateAviatorPermission/SelectedRolePermissionDeleteModalDialog';
import { AddRolePermissionsModalDialog } from '@Features/users/CreateAviatorPermission/AddRolePermissionsModalDialog';
// Localizations
import { CreateLocalizationKeyModalDialog } from '@Features/localizations/CreateLocalizationKey/CreateLocalizationKeyModalDialog';
import { CreateLanguageModalDialog } from '@Features/localizations/CreateLanguage/CreateLanguageModalDialog';

import { SetupUserDrawer } from '@Features/users/UserDrawer/SetupUserDrawer';
import { UpdateMinesProviderConfigModalDialog } from '@Features/provider/updateMinesProviderConfig/UpdateMinesproviderConfigModalDialog';
import { UpdateMinesProviderConfigCancelModalDialog } from '@Features/provider/updateMinesProviderConfig/UpdateMinesProviderConfigCancelModalDialog';
import { SetupMinesRoundDrawer } from '@Features/rounds/SetupMinesRound/SetupMinesRoundsDrawer';
import { SetupRubberDuckRoundDrawer } from '@Features/rounds/SetupRubberDuckRound/SetupRubberDuckRoundsDrawer';
import { TransactionExportModalDialog } from '@Features/transactionExports/TransactionExportModal/TransactionExportModalDialog';
import { CreateRaindropModalDialog } from '@Features/raindrop/Createraindrop/CreateRaindropModalDialog';
import { CreateRaindropCancelModalDialog } from '@Features/raindrop/Createraindrop/CreateRaindropCancelModalDialog';
import { CancelRaindropModalDialog } from '@Features/raindrop/CancelRaindrop/CancelRaindropModalDialog';

export const dialogs = (
  <>
    <CreateProviderModalDialog />
    <CreateProviderConfigModalDialog />
    <CreateProviderConfigCancelModalDialog />
    <UpdateProviderConfigModalDialog />
    <UpdateMinesProviderConfigModalDialog />
    <UpdateProviderConfigCancelModalDialog />
    <UpdateMinesProviderConfigCancelModalDialog />
    <DeleteProviderConfigModalDialog />
    <CreateProviderCancelModalDialog />
    <SetupProviderDrawer />
    <SetupProviderDrawerCancelDialog />
    <DeleteProviderModalDialog />
    <SetupRoundDrawer />
    <CreateRoundConfigModalDialog />
    <SetupMinesRoundDrawer />
    <SetupRubberDuckRoundDrawer />
    <CreateRoundConfigCancelModalDialog />
    <SetupAvTransactionDrawer />
    <CreateUserModalDialog />
    <CreateUserCancelModalDialog />
    <SetupAviatorRoleDrawer />
    <CreateAviatorRoleModalDialog />
    <CancelCreateAviatorRoleModalDialog />
    <SetupAviatorRoleDeleteModalDialog />
    {/* <UpdateRoundStatusModalDialog /> */}
    <CreateAviatorPermissionModalDialog />
    <SelectedRolePermissionDeleteModalDialog />
    <AddRolePermissionsModalDialog />
    <CreateLocalizationKeyModalDialog />
    <CreateLanguageModalDialog />
    <SetupUserDrawer />
    <TransactionExportModalDialog />
    <CreateRaindropModalDialog />
    <CreateRaindropCancelModalDialog />
    <CancelRaindropModalDialog />
  </>
);
